
if (!customElements.get('product-option-value')) {
    class ProductOptionValue extends HTMLElement {
        constructor() {
            super();
            // This Should be the Same String as the Product Display it Belongs to to correlate the events between the two
            this.EventTag = this.dataset.optionEventId
        }

        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            this.querySelector('label')?.addEventListener('click', (evnt) => this.ChangeOption(evnt))
        }
        
        ChangeOption(evnt) {
            // console.log(evnt)
            TriggerEvent(
                this.EventTag, {
                    data: {
                        OptionName: this.dataset.optionName,
                        OptionValue: this.dataset.optionValue,
                        OptionPosition: this.dataset.optionPosition
                    }
                }
            )
        }
    }
    customElements.define('product-option-value', ProductOptionValue)
}